import {
  RavenCheckBox,
  RavenInputField,
  RavenModal,
  toast,
} from "@ravenpay/raven-bank-ui";
import React, { useState } from "react";
import "../../../../styles/dashboard/insights/AlertReceivers.css";
import {
  validateEmail,
  // validatePasswordNumber,
} from "../../../../utils/ValidateInput";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../../redux/types";
import {
  addAlertReceiverFunc,
  getAlertReceivers,
} from "../../../../redux/insight";

interface MyComponentProps {
  visible?: boolean;
  onClose?: () => void;
  onFinish?: () => void;
  onDelete?: (param?: any) => void;
}

const AddAlertReceiver: React.FC<MyComponentProps> = ({
  visible,
  onClose,
  onFinish,
}) => {
  const optionList = [
    { name: "WhatsApp", value: "whatsapp" },
    { name: "Email", value: "email" },
    { name: "SMS", value: "sms" },
  ];

  const [selectedOption, setSelectedOption] = useState<any>([]);

  const dispatch = useDispatch();
  
  const { insight_terminal, loading_reciept } = useSelector(
    (state: RootState) => state.insights
  );

  const noteIcon = (
    <svg
      className="img"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16536_99374)">
        <path
          d="M8.09961 10.8002V8.10022M8.09961 5.40022H8.10636M14.8496 8.10022C14.8496 11.8281 11.8275 14.8502 8.09961 14.8502C4.37169 14.8502 1.34961 11.8281 1.34961 8.10022C1.34961 4.3723 4.37169 1.35022 8.09961 1.35022C11.8275 1.35022 14.8496 4.3723 14.8496 8.10022Z"
          stroke="#EA872D"
          strokeWidth="1.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16536_99374">
          <rect
            width="16.2"
            height="16.2"
            fill="white"
            transform="translate(0 0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  interface formComponent {
    email: string;
    full_name: string;
    phone: string;
  }
  const [details, setDetails] = useState<formComponent>({
    email: "",
    full_name: "",
    phone: "",
  });

  const [showError, setShowError] = useState<boolean>(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const handleSubmit = async () => {
    // console.log(insight_terminal);
    // console.log(details);
    // console.log(selectedOption);

    const obj = {
      tid: insight_terminal?.terminalData?.terminal?.tid,
      serial: insight_terminal?.terminalData?.terminal?.serial,
      phone: details?.phone,
      fname: details?.full_name?.split(" ")[0],
      lname: details?.full_name?.split(" ")[1] || "",
      contact_email: details?.email,
      whatsapp_enabled: selectedOption?.includes("whatsapp") ? "1" : "0",
      sms_enabled: selectedOption?.includes("sms") ? "1" : "0",
      email_enabled: selectedOption?.includes("email") ? "1" : "0",
      poseidon_owner_email:
        insight_terminal?.terminalData?.terminal?.poseidon_business_email,
    };
    // console.log(obj);

    const data = await dispatch(addAlertReceiverFunc(obj as any) as any);
    if (data?.payload?.status === "success") {
      setDetails((prev) => {
        return { ...prev, email: "", full_name: "", phone: "" };
      });
      const inputElement = document.getElementById(
        "inputIdPhoneAlert"
      ) as HTMLInputElement;
      if (inputElement) {
        inputElement.value = ""; // Clear input value
      }
      setSelectedOption([]);
      dispatch(getAlertReceivers({}) as any);
      onFinish && onFinish();
    }
  };

  return (
    <RavenModal
      onBtnClick={() => {
        if (!validateEmail(details.email)) {
          toast.error("Invalid email address!", { position: "top-right" });
          setShowError(true);
          return;
        } else {
          handleSubmit();
        }
      }}
      loading={loading_reciept}
      btnLabel="Add Alert Receiver "
      btnColor="deep-green-light"
      visble={visible}
      onClose={onClose}
      className={`session-expired-wrap-modal`}
      disabled={
        !details?.phone ||
        !details?.full_name ||
        !details?.email ||
        selectedOption?.length < 1
      }
    >
      <div className="alert-receiver-modal-wrap-index">
        <div className="title-text-box">
          <p className="title">Add Alert Recievers</p>
          <p className="text grey-white-color">
            Add alert recievers via email, sms or whatsapp
          </p>
        </div>
        <div className="receiver-list-box">
          <RavenInputField
            color="deep-green-light"
            type="text"
            label="Fullname"
            placeholder="Enter fullname"
            name={`full_name`}
            onChange={handleChange}
            value={details?.full_name}
          />
          <RavenInputField
            color="deep-green-light"
            type="email"
            label="Email Address * "
            placeholder="john@mail.com"
            name={`email`}
            // onChange={handleChange}
            value={details?.email}
            onChange={(e: any) => {
              handleChange(e);
              setShowError(false);
            }}
            showError={showError}
          />
          <RavenInputField
            color="deep-green-light"
            type="phone"
            label="Mobile Number"
            placeholder="E.g 8172783..."
            name={`phone`}
            onChange={handleChange}
            value={details?.phone}
            id="inputIdPhoneAlert"
            key={`guhsjs`}
          />
          <div className="form-group">
            <div className="form-label">Delivery method</div>
            <div className="select-option-list-box">
              {optionList?.map((chi, idx) => {
                return (
                  <div
                    // onClick={() => {
                    //   if (selectedOption?.includes(chi?.value)) {
                    //     const newList = selectedOption?.filter(
                    //       (child: any) => child !== chi?.value
                    //     );
                    //     setSelectedOption(newList);
                    //   } else {
                    //     const newList = [...selectedOption, chi?.value];
                    //     setSelectedOption(newList);
                    //   }
                    // }}
                    key={idx}
                    className="item-select"
                  >
                    <RavenCheckBox
                      id={idx}
                      color="deep-green-light"
                      key={idx}
                      onChange={() => {
                        if (selectedOption?.includes(chi?.value)) {
                          const newList = selectedOption?.filter(
                            (child: any) => child !== chi?.value
                          );
                          setSelectedOption(newList);
                        } else {
                          const newList = [...selectedOption, chi?.value];
                          setSelectedOption(newList);
                        }
                      }}
                      checked={
                        selectedOption?.includes(chi?.value) ? true : false
                      }
                    />
                    <label
                      htmlFor={`input-check-${idx}`}
                      className="name grey-white-color"
                    >
                      {chi?.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
          {/* note box start */}
          <div className="note-box-wrap border-theme grey-bg-two">
            <figure className="img-box">{noteIcon}</figure>
            <p className="text">
              NB: The mobile number included must <br />
              be an active WhatsApp number
            </p>
          </div>
          {/* note box end */}
        </div>
      </div>
    </RavenModal>
  );
};

export default AddAlertReceiver;
